import React, { useState } from 'react';
import Button from 'shared/ui/Button';
import { useDispatch, useSelector } from 'react-redux';
import { selectSchedulersSelected, selectSchedulersTotal, selectSelectedSection } from 'store/Schedule/selectors';
import { Wrapper, Edit } from './styled';
import { openModal } from 'store/modals/actions';
import { MODAL_SCHEDULE_DETAIL } from 'store/modals/modals';
import { setIsCreateSchedule, setSchedulerDetail } from 'store/Schedule/actions';
import { useIntl } from 'react-intl';
import ModalWarning from 'Common/Components/ModalWarning';

const EditButton = () => {
  const [showWarning, setShowWarning] = useState(false);
  const section = useSelector(selectSelectedSection);
  const schedulersCount = useSelector((state) => selectSchedulersTotal(state, section));
  const schedulersSelected = useSelector(selectSchedulersSelected);
  const hasSchedulers = schedulersCount > 0;
  const dispatch = useDispatch();
  const intl = useIntl();
  const message = intl.formatMessage({ id: 'modalWarning.selectOnlyOne' }, { entity: 'scheduler' });

  const handleClick = () => {
    if (hasSchedulers) {
      if ((schedulersSelected?.length === 1)) {
        dispatch(setIsCreateSchedule(false));
        dispatch(setSchedulerDetail(schedulersSelected[0]));
        dispatch(openModal(MODAL_SCHEDULE_DETAIL));
      } else setShowWarning(true);
    }
  };

  const onClose = () => setShowWarning(false);

  return (
    <Wrapper>
      <Button variant="ghost" title="Edit" ariaLabel="Edit" onClick={ handleClick } startIcon={ <Edit /> } />
      { showWarning && <ModalWarning onCloseCallback={ onClose } title="Edit Schedule" description={ message } /> }
    </Wrapper>
  );
};

export default EditButton;
